import Api from '@/services/Api'

export default {
  getFabricGroups (token) {
    return Api().get('/fabricGroups')
  },

  getFabricGroupsByType (type) {
    return Api().get('/fabricGroups/' + type)
  }
}



// WEBPACK FOOTER //
// ./src/services/FabricGroupService.js